// eslint-disable-next-line import/extensions
import './core/process.js';
